export default function getResource(label) {
    const resources = {
        productPrice: 'Price',
        fillSize: 'Fill Size',
        rating: 'Rating',
        ingredientHighlights: 'Ingredient Highlights',
        seeDetails: 'See Full Details',
        value: 'value',
        goodFor: 'Good For',
        targetedConcerns: 'Targets Concerns',
        skinValues: 'Skin',
        hairValues: 'Hair',
        highlyRated: 'Highly Rated By Customers For'
    };

    return resources[label];
}
